(function(angular){
	'use strict';
	
	angular.module('totalOriginationsChartModule', [
		'BaseConfig', 
		'highChartsModule'
	]);

})(window.angular);